var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPersona(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 402,
    height: 354,
    viewBox: "0 0 402 354",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M318.332 68.09C336.897 68.09 351.946 53.0406 351.946 34.4763C351.946 15.9119 336.897 0.862579 318.332 0.862579C299.768 0.862579 284.719 15.9119 284.719 34.4763C284.719 53.0406 299.768 68.09 318.332 68.09Z",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M318.331 61.3227C333.158 61.3227 345.178 49.3032 345.178 34.4763C345.178 19.6494 333.158 7.62986 318.331 7.62986C303.505 7.62986 291.485 19.6494 291.485 34.4763C291.485 49.3032 303.505 61.3227 318.331 61.3227Z",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M318.331 61.3227C333.158 61.3227 345.178 49.3032 345.178 34.4763C345.178 19.6494 333.158 7.62986 318.331 7.62986C303.505 7.62986 291.485 19.6494 291.485 34.4763C291.485 49.3032 303.505 61.3227 318.331 61.3227Z",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M308.799 27.9972L318.332 34.4763H341.774",
    stroke: "#263238",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M320.932 34.4763C320.932 35.9127 319.769 37.0762 318.332 37.0762C316.896 37.0762 315.732 35.9117 315.732 34.4763C315.732 33.0399 316.897 31.8764 318.332 31.8764C319.768 31.8764 320.932 33.0399 320.932 34.4763Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M267.571 313.388C267.571 313.388 271.744 319.211 273.135 322.85C274.526 326.489 272.44 329.036 266.528 331.584C260.616 334.131 256.791 333.767 251.574 334.495C246.358 335.223 243.924 339.59 236.274 341.046C228.623 342.501 222.364 341.41 222.711 338.862C223.059 336.314 232.796 333.403 237.317 327.945C241.837 322.487 250.183 313.025 250.183 313.025L267.571 313.388Z",
    fill: "black",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M267.571 313.388L263.704 313.307L261.529 315.638C261.529 315.638 261.172 316.332 260.729 317.484C259.453 320.8 257.472 327.913 261.139 333.314C262.789 332.963 264.538 332.441 266.528 331.584C272.439 329.037 274.526 326.489 273.135 322.85C271.744 319.211 267.571 313.388 267.571 313.388Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M237.26 238.721C237.26 238.721 246.594 260.75 247.715 271.952C248.835 283.154 268.251 309.664 269.371 311.531C270.491 313.398 268.624 316.385 266.01 317.132C263.397 317.879 258.169 321.985 251.448 318.625C244.727 315.264 239.873 301.822 224.938 282.781C210.003 263.738 196.561 247.309 197.308 238.348C198.055 229.386 208.136 229.013 217.097 230.134C226.058 231.254 237.26 238.721 237.26 238.721Z",
    fill: "#4F4F4F",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M227.925 321.985C227.925 321.985 218.59 331.693 215.23 333.187C211.869 334.68 197.307 339.535 197.307 342.148C197.307 344.762 211.122 346.629 216.723 346.629C222.324 346.629 233.151 342.522 236.512 341.401C239.872 340.281 251.074 338.414 255.181 335.427C259.288 332.44 252.567 320.492 252.567 320.492L227.925 321.985Z",
    fill: "black",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M212.094 346.372C211.857 344.625 211.24 341.779 209.629 338.788C209.062 337.735 208.443 336.849 207.82 336.095C202.803 338.093 197.307 340.543 197.307 342.148C197.308 344.189 205.735 345.775 212.094 346.372Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M246.16 320.881C245.539 322.219 245.026 323.704 244.728 325.346C243.877 330.027 244.481 335.433 245.158 339.22C249.02 338.221 253.053 336.977 255.183 335.427C259.29 332.44 252.569 320.492 252.569 320.492L246.16 320.881Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M176.39 233.562C176.39 233.562 176.629 241.404 183.866 252.537C191.102 263.669 225.374 311.489 225.374 311.489C225.374 311.489 225.374 319.839 225.93 321.508C226.486 323.178 252.648 327.632 254.318 322.622C255.988 317.612 247.638 307.036 247.638 307.036L222.591 236.901C222.591 236.901 214.798 221.315 203.666 219.645C192.532 217.976 176.39 226.326 176.39 233.562Z",
    fill: "#6B6B6B",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M387.462 63.2671L360.046 63.5949C360.046 63.5949 357.422 63.2671 356.765 65.2356C356.765 65.2356 349.876 82.6214 349.549 88.8536C349.221 95.0868 350.861 94.1026 348.237 102.303C345.613 110.504 338.067 129.858 333.803 145.605C328.071 166.768 326.577 189.229 326.214 211.072C326.155 214.578 324.06 244.738 329.516 244.738C334.044 244.738 363.529 250.273 364.032 242.222C366.037 210.133 360.242 178.779 371.388 147.571C375.716 135.451 380.681 122.65 384.353 109.971C388.04 97.2385 388.668 84.1146 391.069 71.1401C392.711 62.2829 387.462 63.2671 387.462 63.2671Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M387.462 63.2671L360.046 63.5949C360.046 63.5949 357.422 63.2671 356.765 65.2347C356.765 65.2347 351.039 79.6889 349.781 86.9622C349.283 88.8372 348.474 92.6913 348.91 96.7642C349.521 102.465 351.149 107.555 359.294 109.591C366.35 111.355 375.077 109.904 378.345 105.248C381.735 102.721 381.098 98.1813 383.197 93.7729C386.478 86.8842 387.79 75.7307 390.414 69.1707C390.677 68.5122 391.003 67.8538 391.349 67.1964C390.958 62.6164 387.462 63.2671 387.462 63.2671Z",
    fill: "#828282",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M382.148 80.0099C379.486 89.593 381.083 92.2546 378.421 108.759C375.759 125.264 366.177 143.897 362.45 160.934C358.723 177.971 360.32 238.131 360.853 240.793C361.055 241.807 361.103 243.438 361.085 245.07C362.872 244.403 363.955 243.478 364.033 242.223C366.038 210.134 360.243 178.78 371.389 147.571C375.717 135.451 380.682 122.65 384.354 109.971C388.041 97.2385 388.669 84.1146 391.07 71.1401C392.077 65.6983 390.486 63.9766 389.107 63.4541L389.069 63.5062C389.069 63.5062 384.81 70.4267 382.148 80.0099Z",
    fill: "#696969",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M299.039 325.779L298.747 325.546V284.853H304.593V259.128H282.961V284.853H288.808V326.244L237.065 342.734V346.827C237.065 349.41 239.159 351.504 241.743 351.504C244.326 351.504 246.42 349.41 246.42 346.827V346.242L289.684 341.211V347.41C289.684 349.671 291.517 351.503 293.776 351.503C296.037 351.503 297.869 349.671 297.869 347.41V341.006L342.887 346.241V346.826C342.887 349.409 344.981 351.503 347.565 351.503C350.148 351.503 352.242 349.409 352.242 346.826V342.733L299.039 325.779Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M298.747 325.545V285.071H288.807V325.559H298.764L298.747 325.545Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M362.795 263.867H230.161C228.032 263.867 226.305 262.14 226.305 260.011V245.21C226.305 243.08 228.032 241.354 230.161 241.354H362.795C364.924 241.354 366.651 243.08 366.651 245.21V260.011C366.651 262.14 364.924 263.867 362.795 263.867Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M232.43 113.691C232.43 113.691 240.327 116.172 243.033 117.075C245.74 117.977 254.764 127.001 254.764 127.001C254.764 127.001 265.593 99.929 266.495 97.4477C267.398 94.9663 267.849 93.3863 267.849 93.3863C267.849 93.3863 263.562 95.1909 259.727 91.1306C255.891 87.0702 260.855 78.9485 256.343 71.9547C251.831 64.9609 224.082 79.8508 223.405 87.0702C222.73 94.2886 225.888 109.63 232.43 113.691Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M209.193 72.1803C209.193 72.1803 209.644 78.2718 211.223 80.7531C212.802 83.2344 214.381 87.7469 213.253 89.7771C212.126 91.8073 208.065 94.064 208.742 96.3198C209.419 98.5756 214.833 99.4779 214.833 99.4779L216.187 102.636C216.187 102.636 220.473 100.155 224.309 101.282C228.143 102.41 235.137 101.057 236.716 96.9955C238.295 92.9352 238.521 78.0452 237.167 67.8934C235.814 57.7415 231.301 53.0034 223.18 55.0346C215.058 57.0657 208.742 66.5399 209.193 72.1803Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M214.18 79.7276C214.18 79.7276 219.46 77.1368 221.983 80.6671",
    stroke: "#263238",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M220.171 85.0834C220.667 86.3617 220.597 87.5801 220.016 87.8048C219.435 88.0303 218.563 87.1762 218.068 85.898C217.572 84.6197 217.642 83.4012 218.223 83.1766C218.804 82.952 219.677 83.8051 220.171 85.0834Z",
    fill: "#263238"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M235.856 40.3981C230.763 41.3853 225.884 43.1041 222.053 44.8827C214.351 48.4591 210.096 54.1322 203.328 53.9067C196.56 53.6811 194.304 56.388 197.913 60.9005C201.523 65.413 207.614 64.9618 207.614 64.9618C207.614 64.9618 202.199 70.151 203.103 73.5347C204.005 76.9183 207.841 76.2416 210.548 72.6324C213.254 69.0232 215.511 64.0595 221.827 62.7061C228.144 61.3526 230.175 61.3526 230.175 61.3526C230.175 61.3526 222.955 66.993 223.858 69.2487C224.76 71.5045 230.851 71.2789 233.558 73.9858C236.265 76.6927 234.009 95.1919 231.754 97.6742C229.498 100.156 226.339 99.2532 222.504 99.0277C218.668 98.8021 215.285 99.7044 216.187 102.637C217.089 105.569 220.487 120.039 223.194 120.941C225.901 121.844 236.354 121.616 247.151 107.444C250.186 103.46 244.838 88.6492 244.838 85.4902C244.838 82.3543 244.56 79.0179 245.326 75.9456C245.776 74.1381 247.369 72.3702 249.343 72.3451C252.071 72.3114 252.912 74.9498 253.411 77.1439C254.539 82.1075 250.93 86.3935 251.606 87.0702C252.283 87.7469 256.795 91.8073 260.63 93.1617C264.465 94.5152 265.142 84.5889 266.947 76.9183C268.752 69.2478 268.752 54.3588 259.727 45.1073C253.923 39.1584 244.574 38.7083 235.856 40.3981Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M222.274 104.969C223.77 104.343 225.386 104.43 225.882 105.165C226.379 105.899 225.569 107.003 224.073 107.63C222.576 108.257 220.961 108.17 220.465 107.435C219.968 106.7 220.777 105.597 222.274 104.969Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M257.026 90.9136C261.827 86.1122 261.827 78.3276 257.026 73.5262C252.224 68.7248 244.44 68.7248 239.638 73.5262C234.837 78.3276 234.837 86.1122 239.638 90.9136C244.44 95.715 252.224 95.715 257.026 90.9136Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M245.515 76.6928L240.733 39.4043C240.635 38.5868 241.253 37.859 242.075 37.8233L249.438 37.5033C250.248 37.4686 250.922 38.1202 250.913 38.9309L250.478 76.4672L245.515 76.6928Z",
    fill: "#C6FF00",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M248.334 89.7771C252.508 89.7771 255.892 86.3934 255.892 82.2194C255.892 78.0453 252.508 74.6616 248.334 74.6616C244.16 74.6616 240.777 78.0453 240.777 82.2194C240.777 86.3934 244.16 89.7771 248.334 89.7771Z",
    fill: "#C6FF00",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M175.582 193.026H150.806V190.37C150.806 185.756 154.546 182.015 159.161 182.015H167.227C171.841 182.015 175.582 185.755 175.582 190.37V193.026Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M237.983 162.838C237.983 162.838 190.572 176.908 187.206 176.908C183.841 176.908 174.359 177.214 168.241 175.991C162.124 174.767 157.535 173.849 155.089 176.296C152.642 178.743 150.807 187.002 150.807 187.002C150.807 187.002 152.03 187.308 154.477 186.39C156.924 185.472 158.454 179.966 158.454 179.966C158.454 179.966 164.877 179.354 167.63 182.107C170.383 184.86 170.077 185.166 168.242 187.001C166.407 188.837 160.902 189.142 159.677 191.283C158.454 193.424 162.736 192.812 164.571 192.507C166.407 192.201 171.301 191.895 174.36 190.366C177.419 188.836 183.536 186.389 185.066 186.084C186.596 185.778 216.573 184.554 226.054 184.554C235.537 184.554 247.772 182.107 253.89 180.272C260.007 178.436 263.373 175.377 263.373 175.377C263.373 175.377 241.959 162.838 237.983 162.838Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M261.23 131.943L249.3 156.415C249.3 156.415 246.241 155.802 245.629 157.638C245.017 159.473 243.488 160.697 243.488 160.697L237.982 162.838C237.982 162.838 243.182 166.814 249.911 172.626C256.641 178.438 261.535 179.356 261.535 179.356C261.535 179.356 273.77 168.038 275.606 155.497C277.441 142.955 266.43 126.438 261.23 131.943Z",
    fill: "#C6FF00",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M178.061 238.571C173.608 230.222 174.72 217.977 205.891 212.41C237.062 206.844 257.795 207.731 257.795 207.731L263.396 200.637C263.396 200.637 331.131 208.514 332.245 210.185C333.358 211.854 331.634 224.612 330.575 231.337C329.516 238.061 328.5 243.781 320.15 246.564C311.801 249.347 274.357 248.592 254.874 246.365C235.393 244.139 204.778 237.459 204.778 237.459",
    fill: "#6B6B6B"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M178.061 238.571C173.608 230.222 174.72 217.977 205.891 212.41C237.062 206.844 257.795 207.731 257.795 207.731L263.396 200.637C263.396 200.637 331.131 208.514 332.245 210.185C333.358 211.854 331.634 224.612 330.575 231.337C329.516 238.061 328.5 243.781 320.15 246.564C311.801 249.347 274.357 248.592 254.874 246.365C235.393 244.139 204.778 237.459 204.778 237.459",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M197.004 248.808C199.025 251.301 200.787 252.937 200.787 252.937",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M285.178 230.457C262.931 230.074 218.569 230.444 209.784 230.444C198.216 230.444 190.504 229.159 191.147 236.871C191.323 238.986 192.127 241.149 193.202 243.175",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M322.251 216.305C322.251 216.305 319.68 220.161 320.323 222.089C320.966 224.017 328.035 225.945 323.536 228.516C319.037 231.087 312.611 228.516 312.611 231.729C312.611 234.942 315.824 238.156 311.326 238.156C306.827 238.156 301.043 232.372 297.83 231.087C297.335 230.888 295.169 230.736 291.82 230.62",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M262.65 208.85C262.65 208.85 289.533 214.824 302.229 225.653",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M269.371 209.597C269.371 209.597 303.349 215.198 317.164 228.64",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M265.943 92.4599C265.943 92.4599 254.931 118.46 251.872 132.836C248.814 147.212 254.625 153.942 257.072 160.977C259.52 168.012 267.473 186.06 267.473 186.06C267.473 186.06 261.355 194.013 260.743 198.907C260.131 203.801 261.661 203.189 282.767 209.306C303.872 215.424 322.837 214.813 327.119 214.506C331.401 214.201 333.849 210.835 334.767 208.389C335.684 205.942 335.99 181.471 332.626 162.812C329.261 144.152 316.414 116.929 298.06 104.082C279.707 91.2347 268.696 90.3189 265.943 92.4599Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M265.943 92.4601C265.943 92.4601 254.931 118.46 251.872 132.836C250.026 141.512 251.415 147.396 253.341 152.25L273.653 92.0282C269.689 91.2097 267.093 91.5664 265.943 92.4601Z",
    fill: "#C6FF00",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M316.541 145.884C317.705 146.039 318.877 146.107 320.051 146.067",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M292.718 132.4C292.718 132.4 301.343 141.372 311.805 144.783",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M296.819 145.611C296.819 145.611 306.842 158.822 320.508 161.1",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M289.529 128.756C289.529 128.756 297.729 132.4 307.752 130.577",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M307.048 190.639C308.698 192.021 310.314 193.558 311.851 195.267",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M282.24 178.867C282.24 178.867 293.372 180.624 304.124 188.368",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M266.717 161.88C266.717 161.88 254.859 166.52 242.229 168.061C229.6 169.601 207.805 170.705 206.583 170.646C205.36 170.587 190.681 163.762 190.681 163.762C190.681 163.762 184.207 158.247 181.458 158.116C178.708 157.985 171.637 158.566 170.968 159.759C170.299 160.952 173.325 161.709 173.325 161.709C173.325 161.709 178.213 161.942 180.047 162.03C181.88 162.118 185.91 167.516 185.91 167.516C185.91 167.516 179.232 166.278 176.787 166.162C174.343 166.045 168.96 169.769 168.915 170.686C168.872 171.602 170.384 171.98 171.912 172.054C173.44 172.127 177.834 169.886 177.834 169.886L185.065 172.376C185.065 172.376 178.183 175.416 177.15 177.816C176.116 180.217 175.054 183.228 175.054 183.228C175.054 183.228 175.286 184.771 177.774 183.971C180.262 183.17 181.368 179.242 181.368 179.242L188.818 177.148C188.818 177.148 183.764 180.151 183.386 181.664C183.007 183.177 181.935 186.619 183.157 186.677C184.38 186.735 187.653 182.299 187.653 182.299L193.241 180.729C193.241 180.729 198.435 180.976 200.88 181.093C203.324 181.21 206.408 180.744 206.408 180.744C206.408 180.744 230.385 185.257 253.911 186.381C277.438 187.504 286.516 183.344 292.875 178.441C299.234 173.538 285.398 161.853 280.204 161.606C275.01 161.358 266.717 161.88 266.717 161.88Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M272.15 105.794C272.15 105.794 264.176 112.456 263.651 123.456C263.126 134.456 268.201 156.441 268.201 156.441L267.416 160.078L263.633 162.347C263.633 162.347 266.717 168.312 278.094 173.756C289.471 179.199 299.466 181.513 301.357 180.379C303.249 179.244 300.442 167.474 300.837 152.793C301.231 138.112 298.265 123.271 295.589 115.182C292.913 107.092 281.768 103.192 278.393 103.337",
    fill: "#C6FF00"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M272.15 105.794C272.15 105.794 264.176 112.456 263.651 123.456C263.126 134.456 268.201 156.441 268.201 156.441L267.416 160.078L263.633 162.347C263.633 162.347 266.717 168.312 278.094 173.756C289.471 179.199 299.466 181.513 301.357 180.379C303.249 179.244 300.442 167.474 300.837 152.793C301.231 138.112 298.265 123.271 295.589 115.182C292.913 107.092 281.768 103.192 278.393 103.337",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M267.415 160.077C267.415 160.077 276.522 168.168 283.825 169.129",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M89.6879 197.853H134.334C136.118 197.853 137.563 196.407 137.563 194.624C137.563 192.839 136.117 191.393 134.334 191.393H89.6879C87.543 191.393 85.482 190.482 84.0379 188.896C82.2613 186.94 81.6231 184.253 82.3345 181.709L98.173 124.952C98.6531 123.234 97.6486 121.451 95.9298 120.972C94.2187 120.49 92.4305 121.497 91.9504 123.215L76.1109 179.973C74.8018 184.671 75.9779 189.629 79.2574 193.24C81.9268 196.173 85.7259 197.853 89.6879 197.853Z",
    fill: "#828282",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M110.891 180.996L121 179.784L105.336 49.0913L95.2278 50.3028L110.891 180.996Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M112.099 46.641L142.304 33.788",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M124.309 178.388L144.875 185.457",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M95.2232 50.3061C95.2232 50.3061 77.2716 114.383 110.893 180.998L95.2232 50.3061Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M168.025 186.678H162.107V189.215H168.025V186.678Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M175.633 186.678H169.715V189.215H175.633V186.678Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M183.242 186.678H177.324V189.215H183.242V186.678Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M190.851 186.678H184.933V189.215H190.851V186.678Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M198.461 186.678H192.543V189.215H198.461V186.678Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M206.07 186.678H200.152V189.215H206.07V186.678Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M213.679 186.678H207.761V189.215H213.679V186.678Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M221.288 186.678H215.37V189.215H221.288V186.678Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M228.785 188.626H158.724V193.439H228.785V188.626Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M242.495 352.551H235.555L234.205 210.521H243.845L242.495 352.551Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M247.865 197.535H42.6958V221.403H247.865V197.535Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M247.518 203.64H42.906V210.676H247.518V203.64Z",
    fill: "#263238"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M251.149 193.366H32.8438V204.483H251.149V193.366Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M71.6679 306.075C71.6679 306.075 51.3786 273.489 49.5335 253.813C47.6894 234.139 62.4453 246.435 62.4453 246.435C62.4453 246.435 41.541 171.425 58.1411 166.507C74.7412 161.588 84.5788 252.583 84.5788 252.583C84.5788 252.583 96.2605 221.226 101.794 231.064C107.327 240.901 95.0305 293.162 95.0305 293.162C95.0305 293.162 108.556 277.176 109.786 287.013C111.016 296.851 96.8746 317.755 96.8746 317.755",
    fill: "#C6FF00"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M109.787 301.156H59.9852L66.2107 352.188H103.562L109.787 301.156Z",
    fill: "#263238"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M98.7207 307.92C98.7207 307.92 109.787 290.705 109.172 279.023C108.557 267.341 99.9498 287.015 99.9498 287.015C99.9498 287.015 107.327 247.666 98.7197 240.288C90.1121 232.91 88.268 275.949 88.268 275.949C88.268 275.949 69.2078 191.716 58.7561 210.161C48.3035 228.607 72.897 274.72 72.897 274.72C72.897 274.72 64.9045 259.349 63.6744 274.104C62.4444 288.86 68.5928 308.536 68.5928 308.536",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M395.836 352.551H400.977",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M1.23901 352.551H384.268",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersona);
export default __webpack_public_path__ + "static/media/persona.06e8c81301d19e72741fa1e51489ac4a.svg";
export { ForwardRef as ReactComponent };